import type * as Types from './types';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { DXError } from '@dx-ui/types-graphql';

export const CreateGuest2FaTotpDocument = {
  operationName: 'createGuest2FATotp',
  operationString: `mutation createGuest2FATotp($language: String!) {
  createGuest2FATotp(language: $language) {
    data
    error {
      code
      context
      message
      notifications {
        code
        fields
        message
      }
    }
  }
}`,
  originalOpName: 'createGuest2FATotp',
};

export function useCreateGuest2FaTotpMutation<TError = DXError, TContext = unknown>(
  options?: UseMutationOptions<
    Types.CreateGuest2FaTotpMutation,
    TError,
    [typeof CreateGuest2FaTotpDocument, Types.CreateGuest2FaTotpMutationVariables],
    TContext
  >
) {
  return useMutation<
    Types.CreateGuest2FaTotpMutation,
    TError,
    [typeof CreateGuest2FaTotpDocument, Types.CreateGuest2FaTotpMutationVariables],
    TContext
  >({
    mutationKey: ['createGuest2FATotp'],
    ...options,
  });
}
